export default __webpack_public_path__ + "static/cashback.url-3feec8121d3bb0123a1a835d54c0f1fc.svg";